export class IncorrectOldPasswordError extends Error {
	constructor() {
		super('Incorrect old password given');
		this.name = 'IncorrectOldPasswordError';
	}
}
